/* @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';
import type { Maybe } from 'bundles/premium-certificate/__generated__/baseContentfulTypes';
import Container from 'bundles/xddp/components/shared/Container';

type Props = {
  disclaimer?: Maybe<string>;
};

const styles: Record<string, Interpolation<Theme>> = {
  disclaimerContainer: css`
    max-width: 760px;
    text-align: center;
  `,
};

const CertificateDisclaimer = ({ disclaimer }: Props) => {
  if (!disclaimer) {
    return null;
  }

  return (
    <div data-test="CertificateDisclaimer">
      <Container css={styles.disclaimerContainer}>
        <Markdown source={disclaimer} />
      </Container>
    </div>
  );
};

export default CertificateDisclaimer;
